/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderJobSeries = new Class({
    Implements: [OCS.Classes.UniqueIdGen, Events, Options, Class.Thenable],
    jobs: {},
    bound_methods: {},
    active_job_id: '',
    job_order: [],
    //TODO: Re work this to handle job completion so that then on load can be safe
    initialize: function (load_spec) {
        this.bound_methods.complete = this.on_complete.bind(this);
        this.addEvent('complete', this.bound_methods.complete);
        var job_id, base_id, i;
        if (Array.isArray(load_spec)) {
            for (i = 0; i < load_spec.length; i++) {
                this.create_job(load_spec[i]);
            }
        } else {
            this.create_job(load_spec);
        }
    },
    create_job: function (options) {
        var job_flags = {'conditional': false, 'async': false};

        var job_ops = {};
        if (typeof options == 'string') {
            job_ops.load = options;
        }

        if (options && options.hasOwnProperty('load')) {
            if (Array.isArray(options.load)) {
                job_ops.load = options.load;
            } else {
                job_ops.load = [options.load];
            }
            if (options.hasOwnProperty('remove_flag')) {
                job_ops.remove = job_ops.load;
            }
        }
        if (options && options.hasOwnProperty('remove')) {
            if (Array.isArray(options.remove)) {
                job_ops.remove = options.remove;
            } else {
                job_ops.remove = [options.remove];
            }
        }
        if (options && options.hasOwnProperty('remove_flag')) {
            job_ops.remove_flag = options.remove_flag;
        }
        if (options && options.hasOwnProperty('condition')) {
            job_flags.conditional = true;
            job_ops.condition = options.condition;
            if (options.hasOwnProperty('yes')) {
                if (Array.isArray(options.yes)) {
                    job_ops.yes = options.yes;
                } else {
                    job_ops.yes = [options.yes];
                }
                if (options.hasOwnProperty('onYes_complete')) {
                    job_ops.onYes_complete = options.onYes_complete;
                }
            }
            if (options.hasOwnProperty('no')) {
                if (Array.isArray(options.no)) {
                    job_ops.no = options.no;
                } else {
                    job_ops.no = [options.no];
                }
                if (options.hasOwnProperty('onNo_complete')) {
                    job_ops.onNo_complete = options.onNo_complete;
                }
            }
        }

        if (options && options.hasOwnProperty('async')) {
            job_flags.async = options.async;
        }
        if (options && options.hasOwnProperty('prepend')) {
            job_ops.prepend = options.prepend;
        }
        if (options && options.hasOwnProperty('onScript_load')) {
            job_ops.onScript_load = options.onScript_load;
        }
        if (options && options.hasOwnProperty('onComplete')) {
            job_ops.onComplete = options.onComplete;
        }
        if (this.debug) {
            job_ops.debug = true;
        }

        // Determine what class we need to load up
        var job_class = this.get_job_class(job_flags);
        var job = new job_class(job_ops);
        var job_id = job.get_job_id();
        this.job_order.push(job_id);
        job.addEvent('script_loaded', this.on_script_loaded.bind(this));
        this.jobs[job_id] = job;
        return job_id;
    },
    on_script_loaded: function (event) {
        this.fireEvent('script_loaded', event);
    },
    on_complete: function () {
        this.jobs = {};
        this.removeEvent('complete', this.bound_methods.complete);
        this.resolve({result: 'success', job: this});

    },

    run: function () {
        var job = this.get_next_job();
        if (job) {
            job.run().then(function (result) {
                this.run.delay(1, this);
            }.bind(this));
        }
    },

    get_job_class: function (job_flags) {
        if (job_flags.async && job_flags.conditional) {
            return OCS.Classes.DynamicScriptLoaderAsyncConditionalJob;
        }
        if (job_flags.async) {
            return OCS.Classes.DynamicScriptLoaderAsyncJob;
        }
        if (job_flags.conditional) {
            return OCS.Classes.DynamicScriptLoaderConditionalJob;
        }
        return OCS.Classes.DynamicScriptLoaderJob;
    },
    get_job: function (job_id) {
        if (this.jobs.hasOwnProperty(job_id)) {
            return this.jobs[job_id];
        }
    },
    get_next_job: function () {
        if (this.job_order.length) {
            this.active_job_id = this.job_order.shift();
            return this.get_job(this.active_job_id);
        } else {
            this.fireEvent('complete', this, 1);
            return false;
        }
    }
});
